import { SaveButton } from "components/Buttons"
import { sortDatesForChart } from "containers/Dashboard/utils"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Col, Row } from "reactstrap"
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts"
import { getAppOpensReports } from "store/actions"

const EngagementTrendsModal = ({
  appOpensReports,
  getAppOpensReports,
  eventId,
}) => {
  const [rangeToggle, setRangeToggle] = useState("year")
  const [chartData, setChartData] = useState([])

  useEffect(() => {
    getAppOpensReports({
      id: eventId,
      days: 365,
    })
  }, [])

  useEffect(() => {
    getAppOpensReports({
      id: eventId,
      type: rangeToggle,
    })
  }, [rangeToggle])

  useEffect(() => {
    const data = sortDatesForChart(appOpensReports, rangeToggle)
    setChartData(
      rangeToggle === "day"
        ? data?.map(x => {
            const formattedDate = new Date(`${x?.date}:00`).toLocaleTimeString(
              [],
              { hour: "numeric" }
            )
            return { ...x, date: x?.date.split(" ")[0] + " " + formattedDate }
          })
        : data
    )
  }, [appOpensReports])

  return (
    <React.Fragment>
      <Row className="d-flex justify-content-end mt-1">
        <Col xs="auto">
          <SaveButton
            type="button"
            color={rangeToggle === "day" ? "primary" : "secondary"}
            size="sm"
            content="Day"
            onClick={() => setRangeToggle("day")}
          />
        </Col>
        <Col xs="auto">
          <SaveButton
            type="button"
            color={rangeToggle === "week" ? "primary" : "secondary"}
            size="sm"
            content="Week"
            onClick={() => setRangeToggle("week")}
          />
        </Col>
        <Col xs="auto">
          <SaveButton
            type="button"
            color={rangeToggle === "month" ? "primary" : "secondary"}
            size="sm"
            content="Month"
            onClick={() => setRangeToggle("month")}
          />
        </Col>
        <Col xs="auto">
          <SaveButton
            type="button"
            color={rangeToggle === "year" ? "primary" : "secondary"}
            size="sm"
            content="Year"
            onClick={() => setRangeToggle("year")}
          />
        </Col>
      </Row>
      <Row style={{ height: "370px" }}>
        <Col>
          <ResponsiveContainer>
            <AreaChart
              data={chartData}
              width={500}
              height={500}
              margin={{
                top: 20,
                right: 30,
                left: 20,
                bottom: 15,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" angle={-20} dy={10} />
              <YAxis allowDecimals={false} />
              <Tooltip cursor={{ fill: "rgb(220, 220, 220, 0.5)" }} />
              <Area
                dataKey="total_views"
                type="monotone"
                name="Total views"
                stroke="#5e5c96"
                strokeWidth={1.5}
                fill="#8884d8"
              />
            </AreaChart>
          </ResponsiveContainer>
        </Col>
      </Row>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  appOpensReports: state.Analytics.appOpensReports,
})

const mapDispatchToProps = dispatch => ({
  getAppOpensReports: values => dispatch(getAppOpensReports(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EngagementTrendsModal)
